export default __webpack_public_path__ + "b1c5440a8cbaf4c955a402462e82b4d9.png";